import { FC, useMemo } from 'react'
import Filter from 'backoffice/components/DropRequests/Filters/Filter'
import { SupplyRequestReviewStatus } from '../types/types'

interface StatusOption {
  value: string
  label: string
}

interface StatusFilterProps {
  value: string | null
  onChange: (status: string | null) => void
  className?: string
}

const StatusFilter: FC<StatusFilterProps> = ({ value, onChange, className }) => {
  const statusOptions: StatusOption[] = useMemo(
    () => [
      { value: SupplyRequestReviewStatus.PENDING, label: 'Pending' },
      { value: SupplyRequestReviewStatus.APPROVED, label: 'Approved' },
      { value: SupplyRequestReviewStatus.REJECTED, label: 'Rejected' },
    ],
    [],
  )

  const selectedOption = useMemo(() => {
    return statusOptions.find((option) => option.value === value) || null
  }, [statusOptions, value])

  const handleChange = (selectedOption: StatusOption | null) => {
    onChange(selectedOption?.value || null)
  }

  return (
    <Filter
      className={className}
      options={statusOptions}
      value={selectedOption}
      onChange={handleChange}
      placeholder="Filter by status"
      isClearable
      isSearchable={false}
    />
  )
}

export default StatusFilter
